import { useNavigate } from "react-router-dom";

import { EmailInput, TextInput, GenericLandingCardHeader } from "./shared";
import {
  onFormChanges,
  setDomainValidation,
  setEmailValidation,
} from "store/slicer/registerFormSlice";
import { useAppDispatch } from "store/store";
import { sendEmailRegister } from "services/AuthenticationService";
import { useSnackbar } from "providers/SnackbarProvider";
import {
  formRegisterAnagrafica,
  inputCognome,
  inputNome,
  RegisterSubTitle,
  RegisterTitle,
  snackbarDetailSuccessSendEmail,
  snackbarSeveritySuccess,
  snackbarSummarySuccessSendEmail,
} from "../_constants";

export const RegisterForm = ({ control, handleSubmit, trigger }: any) => {
  const dispatch = useAppDispatch();

  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const onSubmit = (data: any) => {
    dispatch(onFormChanges(data));
    sendEmailRegister(data)
      .then((_) => {
        showSnackbar({
          severity: snackbarSeveritySuccess,
          summary: snackbarSummarySuccessSendEmail,
          detail: snackbarDetailSuccessSendEmail,
          life: 5000,
        });
        navigate("/verify-email");
      })
      .catch((error) => {
        if (error.response.status === 403) {
          dispatch(setDomainValidation(false));
        }
        if (error.response.status === 409) {
          dispatch(setEmailValidation(false));
        }
      });
  };
  return (
    <>
      <GenericLandingCardHeader
        title={RegisterTitle}
        subtitle={RegisterSubTitle}
      />
      <form
        className="margin-top-32"
        id={formRegisterAnagrafica}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="width-100 flex-container justify-between wrap">
          <div className="width-49 margin-bottom-8">
            <TextInput
              control={control}
              name="name"
              placeholder={inputNome}
              maxLength={275}
            />
          </div>
          <div className="width-49">
            <TextInput
              control={control}
              name="lastName"
              placeholder={inputCognome}
              maxLength={275}
            />
          </div>
          <div className="width-100 margin-bottom-8">
            <EmailInput control={control} trigger={trigger} />
          </div>
        </div>
      </form>
    </>
  );
};
